import React, { ReactElement } from "react";

import { Container, Title, Text } from "./styles";

import DotList from "~/components/DotList";

interface Props {
  title: string;
  items: ReactElement[];
  bottomText: ReactElement;
}

export default function Products({ title, items, bottomText }: Props) {
  return (
    <Container>
      <Title>{title}</Title>
      <DotList items={items} />
      <Text>{bottomText}</Text>
    </Container>
  );
}
